import ParsedDayScheduleCalendar from '@/components/Common/ParsedDayScheduleCalendar';
import { hDeepCopy } from '@/utils/helpers';

export default {
  name: 'CampaignsListItem',

  components: {
    ParsedDayScheduleCalendar,
  },

  props: {
    campaign: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      campaignCopy: null,
    };
  },

  created() {
    this.campaignCopy = hDeepCopy(this.campaign);
  },

  methods: {
    handleGoToProfile() {
      this.$store.commit('campaigns/FILL_ACTIVE_CAMPAIGN', this.campaign)
      this.$router.push({ name: 'PlatformCampaign', params: { campaignUuid: this.campaign.uuid } });
    },
  },
};
